import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { Resource } from '@opentelemetry/resources';
import openTelemetry from '@opentelemetry/api';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { useGetProfileQuery } from '../../features/api/rest/apiProfileSlice';
import config from '../../app/config';

let user = null;
const tracer = openTelemetry.trace.getTracer('FoodAdvisor');
function OpenTelemetryProvider({ children }) {
  const { currentData } = useGetProfileQuery(undefined, { refetchOnMountOrArgChange: true });
  useEffect(() => {
    user = currentData; //  TODO: This is a hack to get the user in the StartPersonalizedSpan function. Find a better way to do this. There is an issue when a page is reloaded, the user is temporarily set to undefined.
  }, [currentData]);
  useEffect(() => {
    const tracking = config.tracking.openTelemetry.tracker;
    if (!sessionStorage.getItem(config.tracking.openTelemetry.sessionIdentifierField)) sessionStorage.setItem(config.tracking.openTelemetry.sessionIdentifierField, Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
    if (tracking === 'true') {
      const exporter = new OTLPTraceExporter({
        url: config.tracking.openTelemetry.url,
      });

      const resource = new Resource({
        [SemanticResourceAttributes.SERVICE_NAME]: config.tracking.openTelemetry.serviceName,
        application: config.tracking.openTelemetry.applicationName,
      });

      const provider = new WebTracerProvider({ resource });
      provider.addSpanProcessor(new BatchSpanProcessor(exporter));

      // Initialize the provider
      provider.register({
        propagator: new W3CTraceContextPropagator(),
        contextManager: new ZoneContextManager(),
      });

      // Registering instrumentations / plugins
      registerInstrumentations({
        instrumentations: [
          new FetchInstrumentation({
            propagateTraceHeaderCorsUrls: [config.tracking.openTelemetry.propagateTraceHeaderCorsUrls], // this is too broad for production
            clearTimingResources: true,
          }),
        ],
      });
    }
    if (tracking === 'false') console.log('Tracking is disabled');
  }, []);

  return [children];
}

export function startSpan(name) {
  const tabIdentifier = sessionStorage.getItem(config.tracking.openTelemetry.sessionIdentifierField);

  const span = tracer.startSpan(name);
  span.setAttribute('User', user?.username);
  span.setAttribute('Session', tabIdentifier);
  return span;
}

OpenTelemetryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OpenTelemetryProvider;
